import {Component, OnInit} from "@angular/core";
import {PrimeNG} from 'primeng/config';
import {OAuthService} from "angular-oauth2-oidc";
import {Router} from "@angular/router";
import {AuthTokenRefreshService} from "../../../../features/core/shared/auth/auth-token-refresh.service";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent implements OnInit{

  topbarTheme = 'white';

  menuTheme = 'light';

  layoutMode = 'light';

  menuMode = 'slim';

  inlineMenuPosition = 'top';

  inputStyle = 'outlined';

  ripple = true;

  isRTL = false;

  isIframe = false;
  loginDisplay = false;

  constructor(
      private primengConfig: PrimeNG,
      private oauthService: OAuthService,
      private router: Router,
      private tokenRefreshService: AuthTokenRefreshService) {

    // AuthTokenRefreshService is instantiated to set up automatic silent refresh

  }

  ngOnInit() {
    this.primengConfig.ripple.set(true);

    if (this.oauthService.hasValidAccessToken()) {
      const redirectUrl = localStorage.getItem('redirectUrl');

      if (redirectUrl) {
        this.router.navigate(['/']).then(() => {
          this.router.navigateByUrl(redirectUrl);
          localStorage.removeItem('redirectUrl');
        });
      }
    }
  }

  login() {
    this.oauthService.initImplicitFlow();
  }

}